import React from "react"
import SchedulingPage, { SchedulingPageDto } from "../state/scheduling-page/SchedulingPage"
import SchedulingPageService from "../state/scheduling-page/SchedulingPageService"
import { getNylasVersion } from "../utils/common/utils"
import CustomFieldsSelectComponent from "./CustomFieldsSelectComponent"

type OwnProps = {
    name?: string,
    editable: boolean,
    schedulingPage: object,
}

const InlineEditSchedulingCustomFields = (props: OwnProps) => {
    const schedulingPage = new SchedulingPage(props.schedulingPage as SchedulingPageDto)
    const nylasKey = getNylasVersion()

    const updateSchedulingPageContactCustomFieldIds = (selectedOptions) => {
        SchedulingPageService.updateCustomFields(
            schedulingPage.getId(),
            nylasKey,
            selectedOptions.map(cfOption => cfOption["value"]),
        )
    }

    return (
        <CustomFieldsSelectComponent
            editable={props.editable}
            name={"scheduling-page-custom-fields"}
            selectedCustomFieldIds={schedulingPage.getContactCustomFieldIds()}
            onSelectChange={(selectedOptions) => { updateSchedulingPageContactCustomFieldIds(selectedOptions) }}
            isAvailableFrom={["persons"]}
            supportedFieldTypes={["text", "date", "single-choice"]}
        />
    )
}

export default InlineEditSchedulingCustomFields


// WEBPACK FOOTER //
// ./src/scheduling-page/InlineEditSchedulingCustomFields.tsx